import {
  FEATURE_PROGRESS,
  type FeatureProgressType,
  type ShowoffItemFormatted,
  type ShowoffElementType,
  type ShowoffStructure,
  type StepType,
  type DashboardItem,
} from '../types';

export const decideToShow = (
  feature: string,
  show: boolean,
  featuresMap: Map<string, string[]>,
  highestOrder: { order: number },
  dashboardItem?: DashboardItem,
  order?: number,
): { notice?: boolean; show?: boolean } => {
  if (!show || (dashboardItem && !dashboardItem.show)) {
    return {};
  }

  if (
    featuresMap.get(FEATURE_PROGRESS.FULL)?.find((item) => item === feature)
  ) {
    if (order && order > highestOrder.order) {
      highestOrder.order = order;
    }
    return {};
  }

  if (
    featuresMap.get(FEATURE_PROGRESS.NOTICED)?.find((item) => item === feature)
  ) {
    return { notice: true };
  }

  return { show: true };
};

const createTree = (
  base: ShowoffStructure,
  featuresMap: Map<FeatureProgressType, ShowoffElementType[]>,
  toShow: ShowoffItemFormatted[],
  steps: StepType[],
  highestOrder: { order: number },
  dashboardItems?: DashboardItem[],
): void => {
  const items = Object.values(base);

  items.forEach((item, index) => {
    steps.push({
      attr: item.attributeName,
      focusType: item.focusType!,
      bypassCondition: item.bypassCondition,
      dismissType: item.dismissType,
    });

    const res = {
      name: item.attributeName,
      ...decideToShow(
        item.attributeName,
        !!item.feature,
        featuresMap,
        highestOrder,
        dashboardItems?.find(
          (dashItem) => dashItem.type === item.attributeName,
        ),
        item.order,
      ),
      order: item.order,
      dismissType: item.dismissType,
    };

    if (item.children) {
      createTree(
        item.children,
        featuresMap,
        toShow,
        steps,
        highestOrder,
        dashboardItems,
      );
    }

    const addToEndOrStart = index > 0 ? 'push' : 'unshift';

    if (res.show) {
      toShow[addToEndOrStart]({ ...res, steps: [...steps], order: res.order });
    } else if (res.notice) {
      toShow[addToEndOrStart]({ ...res, steps: [...steps] });
    }

    steps.pop();
  });
};

export default createTree;
